export function sidebarActions(state) {
  return {
    isGetting: state.docs.isGetting,
    dashboardData: state.docs.status,
    getStatusSuccess: state.docs.getStatusSuccess,
    isLoggingOut: state.auth.isLoggingOut,
    certificates: state.pos.certificates,
  };
}
